import { SearchIcon } from "../../assets";
import styles from "./style.module.css";

interface ISearchBarProps{
  onInputClick?: () => void;
  onInputBlur?: () => void;
}

export const SearchBar: React.FC<ISearchBarProps> = ({onInputClick, onInputBlur}) => {
  return (
    <div className={styles.container}>
      <div className={styles.inputWrapper}>
        <input 
        className={styles.input} 
        placeholder="Search"
        onClick={onInputClick}
        onBlur={onInputBlur}
        />
        <SearchIcon className={styles.icon}/>
      </div>
    </div>
  );
};
